import React from "react"

export const PrintList = () => (<>
  <li>Уведомление о прибытии иностранного гражданина в место пребывания</li>
  <li>Свидетельство о регистрации по месту пребывания</li>
  <li>Свидетельство о регистрации по месту жительства несовершеннолетнего гражданина, не достигшего 14-летнего возраста</li>
  <li>Справка об отсутствии судимости</li>
  <li>Справка об административном наказании за потребление наркотиков</li>
  <li>Адресные справки</li>
  <li>Выписка из электронной трудовой книжки</li>
  <li>Справка об участии в СВО</li>
</>
)
